import RaikoBaseCardContainer from "../../raikoComponents/raikoBaseCardContainer/RaikoBaseCardContainer";
import RaikoGridOneColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridOneColumn";
import UploadPhoto from "../UploadPhoto/UploadPhoto";
import ButtonDivisionSection from "../ButtonDivisionSection/ButtonDivisionSection";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import {useEffect, useState} from "react";
import {MultiMediaService} from "../../pages/multiMediaList/MultiMediaService";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {useParams} from "react-router-dom";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";

const VideoDetailThumbnail = () => {

    const service = new MultiMediaService()
    const snackbar = new SnackbarHelper(useSnackbarDispatcher())
    const loading = new LoadingHelper(useLoadingDispatcher())

    const {id} = useParams()

    useEffect(() => {
        if (typeof id !== 'undefined' && id >= 0) {
            getDataFromServer()
        }
    }, [id])

    function getDataFromServer() {
        loading.show()
        service.getVideoThumbnailInfo(id)
            .then(response => {
                setPhotoUrl(response.url)
                loading.hide()
            }).catch(reason => {

            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در دریافت تصویر شاخص."))
            loading.hide()
        })
    }


    const [photoFile, setPhotoFile] = useState("");
    const [photoUrl, setPhotoUrl] = useState("");

    function handleUpdateThumbnail() {
        if (photoFile) {
            loading.show()
            service.updateMultiMediaThumbnail(id, photoFile)
                .then(response => {
                    snackbar.showSuccessMessage("تصویر شاخص با موفقیت بروزرسانی شد.")
                    loading.hide()
                }).catch(reason => {
                snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در بروزرسانی تصویر شاخص"))
                loading.hide()
            })
        } else
            snackbar.showWarningMessage("لطفا ابتدا فایل تصویر مورد نظر خود را انتخاب نمایید.")
    }

    return (
        <RaikoBaseCardContainer>
            <RaikoGridOneColumn>
                <UploadPhoto
                    photoFile={photoFile}
                    setPhotoFile={setPhotoFile}
                    photo={photoUrl}
                    setPhoto={setPhotoUrl}
                />
                <ButtonDivisionSection>
                    <ButtonPrimaryRaiko label={"بروزرسانی"} onClick={handleUpdateThumbnail}/>
                </ButtonDivisionSection>
            </RaikoGridOneColumn>
        </RaikoBaseCardContainer>
    )
}
export default VideoDetailThumbnail